import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Language = 'en' | 'ar' | 'ru';

interface LanguageState {
  language: Language;
  setLanguage: (lang: Language) => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      language: 'en', // Default language
      setLanguage: (language) => set({ language }),
    }),
    {
      name: 'language-store',
    }
  )
);